import MarkdownIt from 'markdown-it';
import MarkdownSlack from 'lib/markdown-slack';
import MarkdownEmojis from 'markdown-it-emoji';
import twemoji from 'twemoji';    

import emojis from './emojis';
import TurndownService from "turndown";

export const turndownService = new TurndownService({
  headingStyle: 'atx',
  strongDelimiter: '**',
  linkReferenceStyle: 'collapsed', 
})

turndownService.addRule('strikethrough', {
  filter: ['del', 's'],
  replacement: function (content) {
      return '~' + content + '~'
  }
});

turndownService.addRule('bold', {
  filter: ['strong', 'b'],
  replacement: function (content) {
      return '*' + content + '*'
  }
});

turndownService.addRule('anchor', {
  filter: (node, options) => (
    Boolean(
      options.linkStyle === 'inlined' &&
      node.nodeName === 'A' &&
      node.getAttribute('href')
    )
  ),
  replacement: (content) => content,
});

export function replaceAll(str, find, rep) {
  return str.split(find).join(rep)
}

export function emojiToTwemoji(obj) {
  const found = {};

  twemoji.parse(obj, {
    callback: icon => {
      const item = emojis.lookup[icon];

      if (item) {
        found[item.emoji] = item.code;
      }
      
      return false;
    }
  });

  let out = obj;

  for (const key in found) {
    out = replaceAll(out, key, `:${found[key]}:`);
  }

  return out;
}

export function emojiParse(obj) {
  return twemoji.parse(obj, {
    callback: icon => {
      return `/static/emojis/72x72/${icon}.png`;
    }
  });
}

const md = MarkdownIt({ breaks: true });
md.use(MarkdownSlack);
md.use(MarkdownEmojis, {});

md.renderer.rules.emoji = function(token, idx) {
  return emojiParse(token[idx].content) as any;
};

export { md };